<template>
  <div>
    <Header />
    <div class="main">
      <div
        class="container o-container o-container--large booking-process reserva"
        id="RESERVA"
        role="main"
      >
        <div
          id="breadcrumbs-form"
          name="breadcrumbs-form"
          data-partialsubmit="true"
        >
          <nav class="navbar navegacion2" role="navigation" id="navegacion2">
            <div
              id="j_id_2v:breadcrumbs-availability"
              class="wrapperNavbar breadcrumbs-availability"
            ></div>
            <div id="breadcrumb-bottom"></div>
          </nav>
          <input
            type="hidden"
            name="breadcrumbs-form_SUBMIT"
            value="1"
            autocomplete="off"
          /><input
            type="hidden"
            name="javax.faces.ViewState"
            id="j_id__v_0:javax.faces.ViewState:2"
            value="ZTMyZWRmOTlkZDczM2Y1YTAwMDAwMDA5"
            autocomplete="off"
          />
        </div>
        <div class="o-layout">
          <div
            id="col-left"
            class="o-layout__item u-float--left u-12/12 u-3/12@md"
          >
            <div class="col-left--box">
              <div
                id="comp-summary"
                class="ongoing hidden-print comp-summary only-hotel"
              >
                <nav
                  class="float-breadcrumb navbar o-position o-position--above o-position--fixed o-position--top u-1/1"
                  role="navigation"
                  id="navegacion"
                  style="display: none; z-index: 1001"
                >
                  <header class="nav-brochure">
                    <div
                      id="j_id_4v:breadcrumbs-availability"
                      class="wrapperNavbar breadcrumbs-availability"
                    ></div>
                  </header>
                </nav>
                <div class="c-fast-confirm mb-10 true">
                  <div
                    class="c-fast-confirm__heading o-layout o-layout--stretch o-layout--stretch--middle"
                  >
                    <b class="u-font-weight--600">
                      {{ $func.parseIso("resortSummary") }}</b
                    >
                  </div>
                  <div
                    class="c-fast-confirm__hero c-fast-confirm__hero--destination"
                  >
                    <div class="c-fast-confirm__hero__wrapper-img">
                      <img
                        data-src="https://cdn5.travelconline.com/unsafe/fit-in/0x200/filters:quality(75):format(webp)/https%3A%2F%2Ftr2storage.blob.core.windows.net%2Fimagenes%2FDydSA3d4NdjY-2CNsl1uTcl4DDyY.jpeg"
                        src="https://cdn5.travelconline.com/unsafe/fit-in/0x200/filters:quality(75):format(webp)/https%3A%2F%2Ftr2storage.blob.core.windows.net%2Fimagenes%2FDydSA3d4NdjY-2CNsl1uTcl4DDyY.jpeg"
                        data-index=""
                        data-error-src="/javax.faces.resource/images/no-photo-XS.jpg"
                        onerror="this.setAttribute('data-original-url', this.src); var errorUrl = this.getAttribute('data-error-src'); if(this.src !== errorUrl) {this.src = errorUrl};"
                        loading="lazy"
                        alt="Miami FL"
                        width=""
                        height=""
                        onclick=""
                        style=""
                        class="lazy-img c-fast-confirm__hero__img loaded"
                        data-ll-status="loaded"
                      />
                    </div>
                    <div
                      class="c-fast-confirm__hero__body u-text-align--center"
                    >
                      <span>Accommodations in</span>
                      <b
                        class="u-display--block u-font-size--big c-fast-confirm__hero__title"
                      >
                        {{ week.ResortCountry }}, {{ week.ResortCity }}
                      </b>
                    </div>
                  </div>
                  <div class="c-fast-confirm__body o-box--default--vertical">
                    <div
                      class="tc-tooltip rewards-accumulation c-fast-confirm__float-icon c-fast-confirm__float-icon--cup"
                      title=""
                      data-original-title="You will earn 0 points, available from the end of the trip on 29 Apr 2024 "
                    >
                      <!-- <i class="fa-regular fa-trophy clr--rewards-trophy"></i> -->
                    </div>
                    <div
                      id="j_id_4v:j_id_74:precioTotal"
                      class="c-price clr--dark-gray u-text-align--center precioTotal"
                    >
                      <div
                        class="c-price__primary dev-side-summary-priceShown c-fast-confirm__price u-font-size--giant u-font-size--huge@md u-font-size--giant@lg"
                      >
                        $ {{ price }} USD
                      </div>
                      <div class="c-price__bottom u-font-size--small">
                        {{ $func.parseIso("finalPrice") }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="c-travel-details">
                  <div
                    class="c-travel-details__container u-display--flex@sm u-display--block@md u-gap--small"
                  >
                    <div
                      class="c-travel-details__item c-travel-detail c-travel-details__item--people o-layout__item u-1/2@sm u-1/1@md"
                    >
                      <div class="c-travel-detail__icon">
                        <i class="fa-regular fa-users"></i>
                      </div>
                      <div class="c-travel-detail__content">
                        {{ week.UnitType }} / {{ week.KitchenType }}
                      </div>
                    </div>
                    <div
                      class="c-travel-details__item c-travel-detail c-travel-details__item--dates o-layout__item u-1/2@sm u-1/1@md"
                    >
                      <div class="c-travel-detail__icon">
                        <i class="fa-regular fa-calendar-lines"></i>
                      </div>
                      <div
                        class="c-travel-detail__content trip-departure-arrival-dates"
                      >
                        {{ formatDate(week.CheckInDate) }} -
                        {{ formatDate(week.CheckOutDate) }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div
                  id="c-hidden-aside"
                  class="c-hidden-aside c-hidden-aside@md modifier pt-0"
                >
                  <div
                    class="c-sticky-header u-zindex--128 u-display--none@md o-block__item o-position--top o-position--sticky"
                  >
                    <div class="o-flexbox o-flexbox--generic-row">
                      <div
                        class="o-flexbox o-flexbox--generic-row u-align-items--center"
                      >
                        <a class="c-sticky-header__button ux-close-filters"
                          ><i class="fa-regular fa-arrow-left"></i
                        ></a>
                        <div class="u-line-height--1 u-ellipsis-inline">
                          <b> Filter and Sort</b>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="o-block c-hidden-aside__scroller">
                    <div
                      id="j_id_4v:j_id_tc:side-summary-aside"
                      class="side-summary-aside o-block__item"
                    >
                      <div class="tab-content mb-20">
                        <div
                          role="tabpanel"
                          class="tab-pane active"
                          id="side-travel-route"
                        >
                          <b
                            class="sidebar__title u-display--none u-display--inline-block@sm mb-10 mt-10 clr--dark-gray"
                          >
                            Your trip day to day
                          </b>
                          <div
                            class="mb-10 travel-route travel-route--without-origin false hidden-xs travel-route--hover-null"
                            data-content="Browse service by service in this column"
                            data-placement="top"
                          >
                            <div class="travel-route__travelling">
                              <div
                                class="travel-route__destination parent-clr--1"
                              >
                                <div
                                  class="travel-route__item travel-route__city travel-route__city--destination"
                                >
                                  <div class="c-route-date child__bg-clr">
                                    <b class="c-route-date__title"> 13</b
                                    ><span class="c-route-date__small">Apr</span
                                    ><span
                                      class="c-route-date__arrow child__bdr-clr--top"
                                    ></span>
                                  </div>
                                  <div class="c-route-step">
                                    <div
                                      class="c-route-step__line--top u-opacity--0"
                                    ></div>
                                    <div
                                      class="c-route-step__point c-route-step__point--lg child__clr"
                                    >
                                      <i
                                        class="fa-regular fa-map-marker-alt u-font-size--middle"
                                      ></i>
                                    </div>
                                    <div
                                      class="c-route-step__line--bottom"
                                    ></div>
                                  </div>
                                  <div class="travel-route__content">
                                    <h5 class="travel-route__city-name">
                                      Miami FL
                                    </h5>
                                  </div>
                                </div>
                                <div
                                  class="travel-route__item travel-route__hotel"
                                >
                                  <div
                                    class="c-route-date child__bg-clr--white-soft"
                                  >
                                    <i
                                      class="fa-regular fa-moon c-route-date__title"
                                    ></i
                                    ><span class="c-route-date__small">16</span>
                                  </div>
                                  <div class="c-route-step">
                                    <div class="c-route-step__line--top"></div>
                                    <div class="c-route-step__point child__clr">
                                      <i class="fa-regular fa-bed-alt"></i>
                                    </div>
                                    <div
                                      class="c-route-step__line--bottom"
                                    ></div>
                                  </div>
                                  <div
                                    class="travel-route__content travel-route__service-content"
                                  >
                                    <a
                                      href="/accommodation/accommodationCityAvail.xhtml?tripId=1&amp;availPosition=1"
                                      class="travel-route__service-details"
                                      title="Click to see all hotels in this city"
                                    >
                                      <h6
                                        class="travel-route__service__list-item travel-route__service-title"
                                      >
                                        Clarion Inn &amp; Suites Miami
                                        International Airport
                                      </h6>
                                      <div
                                        class="travel-route__service__list-item c-hotel-status c-hotel-status--sm"
                                      >
                                        <div class="c-hotel-status null mt-5">
                                          <span
                                            class="c-hotel-status__category null"
                                            ><i
                                              class="fa-solid fa-star c-hotel-status__star"
                                            ></i
                                            ><i
                                              class="fa-solid fa-star c-hotel-status__star"
                                            ></i
                                            ><i
                                              class="fa-solid fa-star c-hotel-status__star hidden"
                                            ></i
                                            ><i
                                              class="fa-solid fa-star c-hotel-status__star hidden"
                                            ></i
                                            ><i
                                              class="fa-solid fa-star c-hotel-status__star hidden"
                                            ></i
                                            ><i
                                              class="fa-solid fa-star c-hotel-status__star hidden"
                                            ></span
                                          >
                                          <b
                                            class="c-hotel-status__popularity clr--rating75"
                                          >
                                            6.5
                                            <i
                                              class="fa-regular fa-thumbs-up"
                                            ></i>
                                          </b>
                                        </div>
                                      </div>
                                      <div
                                        class="travel-route__service__list-item o-group mt-5"
                                      >
                                        <i class="fa-light fa-location-dot"></i
                                        ><b class="u-font-size--small">
                                          Miami Springs</b
                                        >
                                      </div>
                                      <div
                                        class="travel-route__service__list-item travel-route__hotel-plan"
                                      >
                                        <span
                                          ><i
                                            class="fa-regular fa-utensils travel-route__detail-icon"
                                          ></i>
                                          room only</span
                                        >
                                        <span
                                          ><i
                                            class="fa-regular fa-bed travel-route__detail-icon"
                                          ></i>
                                          run of house</span
                                        >
                                      </div></a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div class="travel-route__insurances-list"></div>
                          </div>
                          <div id="mbox-widget"></div>
                        </div>
                        <div
                          role="tabpanel"
                          id="tab-sort"
                          class="tab-pane u-display--none@md"
                        >
                          <div
                            id="j_id_4v:j_id_tc:aside-sort"
                            class="sort-selector o-block o-block--small u-line-height--1"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="u-display--none@md">
                    <div class="o-box--small bg-clr--white">
                      <a
                        href="#"
                        class="c-button c-button--solid--default bg-clr--brand u-1/1"
                        onclick="closeHiddenAside()"
                        ><span>Apply</span></a
                      >
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <div
            class="passsenger-data comp-app o-layout__item u-float--left u-12/12 u-9/12@md pl-0 pl-20@md pl-40@lg"
          >
            <TravelerForm :week="week" :iso="iso" @back="goBack" />
          </div>
        </div>
      </div>
    </div>
    <div
      id="j_id_4b_6h:privacyPolicy"
      class="c-modal privacyPolicy c-modal-cookies-privacy"
      data-size="large"
      role="dialog"
      data-closeable="true"
      tabindex="-1"
      aria-modal="true"
      data-active="true"
      style="display: block; z-index: 1050; width: 100%"
      v-if="showLogin"
    >
      <LoginGuest />
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import LoginGuest from "./LoginGuest.vue";
import TravelerForm from "../components/TravelerForm.vue";
import { getSesion } from "../utils/sesions";

export default {
  data() {
    return {
      weekId: null,
      weekInventoryId: null,
      week: null,
      price: null,
      iso: null,
      showLogin: false,
    };
  },
  components: {
    Header,
    LoginGuest,
    TravelerForm,
  },
  async created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
      this.$forceUpdate();
    });

    await this.checkParams();
    await this.listWeek();
    await this.$bus.emit("footer-show", true);
    await this.checkAuth();
  },
  methods: {
    async checkParams() {
      const { weekId, weekInventoryId } = this.$route.query;
      this.weekId = weekId || null;
      this.weekInventoryId = weekInventoryId || null;
    },
    async listWeek() {
      const procesarParametroQuery = (textoQuery) => {
        const decodificado = decodeURIComponent(textoQuery);
        return decodificado.replace(/ /g, "+");
      };

      if (this.weekInventoryId) {
        try {
          const { data } = await this.$axios.post(
            `/week/only-inventory?isInventory=y`,
            {
              inventoryId: procesarParametroQuery(this.weekInventoryId),
            }
          );
          this.week = data.week;
          this.price = data.week.Cost;
        } catch (error) {
          console.log(error);
        }
      } else if (this.weekId) {
        try {
          const { data } = await this.$axios.get(`/week/only/${this.weekId}`);
          this.week = data.week;
          this.price = data.week.Cost;
        } catch (error) {
          console.log(error);
        }
      } else this.$router.push("/");
    },
    goBack() {
      this.$router.go(-1);
    },
    formatDate(date) {
      return this.$moment(date).format("ll");
    },
    checkAuth() {
      const sesionTC = getSesion();
      if (sesionTC) {
        this.showLogin = false;
      } else this.showLogin = true;
    },
  },
};
</script>
